import { ComponentType, useState } from 'react';

import { ChevronRight, InfoIcon } from 'lucide-react';

import { Button, Modal } from '@sandtech-hub-monorepo/ui-kit';

export interface ProofOfCompletionModalProps {
  close: () => void;
  classEnrollmentId: string;
}

interface ProofOfCompletionBannerProps {
  modal: ComponentType<ProofOfCompletionModalProps>;
  classEnrollmentId: string;
  text: string;
  displayCta?: boolean;
  ctaText: string;
}

export const ProofOfCompletionBanner: React.FC<
  ProofOfCompletionBannerProps
> = ({
  modal: ModalComponent,
  classEnrollmentId,
  text,
  displayCta = true,
  ctaText,
}: ProofOfCompletionBannerProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="flex gap-2 px-4 py-2 mt-2 rounded-lg bg-background-quaternary border border-primary text-primary">
        <InfoIcon size={24} />
        <p className="w-fit font-medium">{text}</p>
        {displayCta && (
          <Button
            variant="link"
            className="h-fit w-fit p-0 ml-1 text-base font-semibold"
            onClick={() => setOpen(true)}
          >
            {ctaText}
            <ChevronRight />
          </Button>
        )}
      </div>
      <Modal open={open} onOpenChange={setOpen}>
        {ModalComponent && (
          <ModalComponent
            close={() => setOpen(false)}
            classEnrollmentId={classEnrollmentId}
          />
        )}
      </Modal>
    </>
  );
};
